import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, ElementRef, Input, Pipe, PipeTransform, AfterViewInit } from '@angular/core';
import { UntypedFormBuilder,FormArray, Validators, ValidationErrors, ControlContainer, FormGroupDirective, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { Location } from '@angular/common'

import { merge, fromEvent } from 'rxjs';
import { debounceTime, distinctUntilChanged, startWith, tap, delay } from 'rxjs/operators';

import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

import * as FileSaver from 'file-saver';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { GlobalsService } from '../../services/globals.service';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { CustomerService } from '../../services/customer.service'

import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';

declare let $: any;

@Component({
	selector: 'app-matrix-copy',
	templateUrl: './matrix-copy.component.html',
	styleUrls: ['./matrix-copy.component.scss']
})
export class MatrixCopyComponent implements OnInit {
	color: any = 'blue';
	fromcustomer = new FormControl('');
	tocustomer = new FormControl('');
	customersearchsubscription: any = false;
	sending: any = false;
	fromresults: any = false;
	toresults: any = false;
	from:any = false;
	to:any = false;
	transactions: any = false;
	matrix: any = false;
	warning: any = '';

	form = new FormGroup({
		items: new FormArray([])
	});
	selected: any = [];

	constructor(private route: ActivatedRoute, private location: Location, public router: Router, public cdr: ChangeDetectorRef, private globalSearchService: GlobalSearchService, private fb: UntypedFormBuilder, public globalsService: GlobalsService, private modalService: NgbModal, private customerService: CustomerService) {

		this.color = this.globalSearchService.getColor();
	}

	ngOnInit(): void {}

	back(): void {
		this.location.back();
	}


	checkAll(event:any) {
		if(event.target.checked) {
			this.selected = this.transactions.transactions;
		} else {
			this.selected = [];
		}
	}
	copyMatrix() {
		const ok = confirm('Are you sure you wish to continue?');
		if(ok) {
			const data = {
				from: this.from.debtorno,
				to: this.to.debtorno
			}

			this.customerService.copyMatrixData(data).subscribe((r:any) => {
				if(r.success) {

					this.globalSearchService.showNotification('Matrix Copied', 'success', 'bottom', 'right');
					this.to = false;
					this.from = false;
					this.matrix = false;
					this.tocustomer.setValue('');
					this.fromcustomer.setValue('');
					this.warning = '';
				}

			})
		}
	}
	addRemove(event: any, trans: any) {
		if(event.target.checked) {
			this.selected.push(trans)
		} else {
			const index = this.selected.indexOf(trans);
			this.selected.splice(index,1);
		}
	}
	setFrom(value:any) {
		this.from = value
		this.customerService.getPriceMatrix(value.debtorno).subscribe((r:any) => {
			this.matrix = r;
		})
	}
	setTo(value:any) {
		this.to = value;
		this.customerService.getPriceMatrix(value.debtorno).subscribe((r:any) => {
			if(r.customer_matrix.length > 0){
				this.warning = 'Existing price matrix for customer '+r.debtorno+' will be replaced with the data below.';
			}
		})
	}
	get control() {
		return this.form.get('items') as FormArray;
	}

	customerSearch(keyword: string, type: 'from' | 'to'): void {
	  const search: any = {
			source: 'copymatrix',
			keywords: keyword,
			...(type === 'from' ? { salestype: 'M' } : {})
	  };

	  if (this.customersearchsubscription) {
			this.customersearchsubscription.unsubscribe();
	  }

	  this.sending = true;

	  this.customersearchsubscription = this.customerService.getCustomerSearch(search).subscribe((results: any) => {
			this.sending = false;
			if (type === 'from') {
		  this.fromresults = results;
			} else {
		  this.toresults = results;
			}
	  });
	}


	displayFn(results: any): string {
		if(results) {
			return results.debtorno+' '+results.name;
		} else {
			return '';
		}

	}

}
